// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IZ3Ijim8OiKRFpUBEPag {
  width: 570px !important;
}

.U17vLgUgGON9b1x9spmW {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 70vh !important;
}

.Aoo60d_kqrUI0vr1yUBB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  max-height: 471px;
  width: 471px;
  margin-bottom: 24px;
  overflow-y: auto;
}

.BXxHWZ3OjQ1qyK5l4Dfy {
  border-radius: 4px;
  margin-bottom: 12px;
  width: 377px;
  height: 38px;
}

.VocI4jZqftRKuDbGRt2V {
  margin-bottom: 4px;
  display: block;
}

.wE369EtUn76Jjy7shdf_ {
  display: block;
  width: 100%;
  height: auto;
}

.wE369EtUn76Jjy7shdf_ audio {
  display: block;
  margin: 0.5rem auto;
}

._77EeJfVSXCFgz6KBXkS {
  width: 100%;
  height: 471px;
}

.IUlWTBEoJpkVY3esH51S {
  min-height: 40px;
}

.IUlWTBEoJpkVY3esH51S img {
  width: 100%;
}

._77EeJfVSXCFgz6KBXkS iframe {
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/PreviewModal/PreviewModal.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".modal-layout {\n  width: 570px !important;\n}\n\n.body-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-height: 70vh !important;\n}\n\n.preview-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: auto;\n  max-height: 471px;\n  width: 471px;\n  margin-bottom: 24px;\n  overflow-y: auto;\n}\n\n.text-container {\n  border-radius: 4px;\n  margin-bottom: 12px;\n  width: 377px;\n  height: 38px;\n}\n\n.label {\n  margin-bottom: 4px;\n  display: block;\n}\n\n.embedWidenContainer {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.embedWidenContainer audio {\n  display: block;\n  margin: 0.5rem auto;\n}\n\n.embedWidenContainer-document {\n  width: 100%;\n  height: 471px;\n}\n\n.embedWidenContainer-image {\n  min-height: 40px;\n}\n\n.embedWidenContainer-image img {\n  width: 100%;\n}\n\n.embedWidenContainer-document iframe {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-layout": `IZ3Ijim8OiKRFpUBEPag`,
	"body-container": `U17vLgUgGON9b1x9spmW`,
	"preview-container": `Aoo60d_kqrUI0vr1yUBB`,
	"text-container": `BXxHWZ3OjQ1qyK5l4Dfy`,
	"label": `VocI4jZqftRKuDbGRt2V`,
	"embedWidenContainer": `wE369EtUn76Jjy7shdf_`,
	"embedWidenContainer-document": `_77EeJfVSXCFgz6KBXkS`,
	"embedWidenContainer-image": `IUlWTBEoJpkVY3esH51S`
};
export default ___CSS_LOADER_EXPORT___;
